import styled from 'styled-components';
import cardone from '../../assets/cardone.png';
import cardtwo from '../../assets/cardtwo.png';
import cardthree from '../../assets/cardthree.png';

import axios from 'axios';
import React, { useState, useEffect, useContext } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { fetchVisitorTypes, fetchMeetingVenues, insertAppointment, fetchGateDetails, fetchNationality, fetchBuildingsByGate } from '../../services/Api';

const Container = styled.div`
  padding: 28px;
  display: flex;
  flex-direction: column;
  align-items: flex-start; /* Align items to the start (left) */
`;

const Heading = styled.h1`
  font-size: 24px;
  font-family: 'Segoe UI', 'Semibold';
  margin-bottom: 20px;
    color:#293495;

`;

const CardWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  flex-wrap: wrap;
`;

const Card = styled.div`
  width: 288px;
  height: 101px;
  background-color: ${(props) => props.bgColor || '#fff'};
  box-shadow: 0px 10px 10px #00000038;
  border: 3px solid #FFFFFF;
  border-radius: 10px;
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 320px) {
    width: 90%;
  }
        @media (max-width: 1920px ) and (min-width: 1720px ) {
    width: 30%;

  }
       @media (max-width: 1720px ) and (min-width: 1520px ) {
    width: 30%;

  }
       @media (max-width: 1520px ) and (min-width: 1320px ) {
    width: 30%;

  }
      @media (max-width: 1320px ) and (min-width: 1120px ) {
    width: 30%;

  }
      @media (max-width: 1120px ) and (min-width: 920px ) {
    width: 30%;

  }
`;

const CardContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 90%;
`;

const CardImage = styled.img`
  width: 35px;
  height: 40px;
`;

const CardText = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  font-family: 'Segoe UI', 'Semibold';
`;

const CardTitle = styled.h2`
  font-size: 18px;
  color: ${(props) => props.textColor || '#000'};
`;

const CardSubtitle = styled.p`
  font-size: 14px;
  color: ${(props) => props.textColor || '#000'};
  margin-top: -1px;
`;

const CardCount = styled.div`
  font-size: 24px;
  color: ${(props) => props.textColor || '#000'};
  font-family: 'Segoe UI', 'Semibold';
`;

const SubHeading = styled.h2`
  font-size: 20px;
  font-family: 'Segoe UI', 'Semibold';
  margin: 5px 0;
    color:#293495;

`;


const RadioGroup = styled.div`
  display: flex;
  margin: 20px 0;
`;

const RadioLabel = styled.label`
  font-size: 16px;
  font-family: 'Segoe UI', 'Semibold';
  color: #000;
  margin-right: 20px;
  font-weight: 600;
`;

const RadioInput = styled.input`
  margin-right: 10px;
`;


const InputCard = styled.div`
  width: 374px;
  height: 182px;
  background: #fff;
    box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
  opacity: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;  
  margin: 20px auto 0;
  position: relative;
`;
const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 80%;
  height: 40px;
  border-bottom: 2px solid #2B3497;
  font-size: 14px;
  color: #000;
    margin-bottom: 20px;


  span {
    font-weight: bold;
    margin-right: 5px;
  }
`;

const StyledInput = styled.input`
  background-color: transparent;
  flex: 1;
  height: 40px;
  font-size: 14px;
  border: none;
  outline: none;
  text-align: left;
  &::placeholder {
    color: #000;
  }
`;
const ISDInput = styled.input`
  width: 50px;
  background-color: transparent;
  height: 40px;
  font-size: 14px;
  border: none;
  outline: none;
  text-align: center;
  color: #000;
`;
const InputField = styled.input`
  background-color: transparent;
  width: 80%;
  height: 20px;
  padding: 10px;
  font-size: 14px;
  margin-bottom: 20px;
  border: none;
  border-bottom: 2px solid #2B3497;
  border-radius: 0;
  text-align: left;
  outline: none;

  &::placeholder {
    color: #000000;
  }

  /* Remove up and down arrows for number input */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &::-moz-appearance {
    textfield;
  }
`;

const Button = styled.button`
  background-color: #2B3497;
  color: #fff;
  font-size: 16px;
  padding: 10px 20px;
  border: none;
  border-radius: 7px;
  box-shadow: 0px 10px 20px #2B349747;
  opacity: 1;
  cursor: pointer;
  width: 150px;
`;
const Popup = styled.div`
  position: fixed;
  top: 50%;
  left: 55%;
  transform: translate(-50%, -50%);
  background: linear-gradient(#FFFFFF, #F5F5F5, #FFFFFF);
  box-shadow: 0px 0px 45px #0000004A;
  border-radius: 30px;
  padding: 30px;
  text-align: center;
  opacity: 1;
  z-index: 1000;
  width: 400px;
  height: 125px;
`;
const ISDSelect = styled.select`
  width: 80px;
  background-color: transparent;
  height: 40px;
  font-size: 14px;
  border: none;
  outline: none;
  text-align: center;
  color: #000;
  cursor: pointer;
`;
const PopupText = styled.p`
  font-size: 18px;
  color: #2B3497;
  margin-bottom: 20px;
`;

const PopupButton = styled.button`
  background-color: #2B3397;
  color: #fff;
  font-size: 16px;
  padding: 10px 20px;
  border: none;
  border-radius: 12px;
  box-shadow: 0px 10px 20px #2B349754;
  opacity: 1;
  cursor: pointer;
`;

const GroupCheckoutPage = () => {
  const [selectedOption, setSelectedOption] = useState('mobile');
  const [mobileNumber, setMobileNumber] = useState('');
  const [qrumber, setQrNumber] = useState('');
  const [cardCounts, setCardCounts] = useState({
    mobileCheckOutCount: 0,
    qrcodeCheckOutCount: 0,
    totalcodeCheckOutCount: 0,

  });
  const [showPopup, setShowPopup] = useState(false);
  const [showPopupSuc, setShowPopupSuc] = useState(false);
  const [nationalityList, setNationalityList] = useState('');
  const [defaultNationalityCode, setDefaultNationalityCode] = useState('');
  const handleIsdChange = (e) => {
    setMobileNumber('')

    const selectedNationality = nationalityList.find(
      (nation) => nation.nationalityCode === e.target.value
    );

    if (selectedNationality) {
      console.log("Selected Nationality Code:", selectedNationality.nationalityCode);
      setDefaultNationalityCode(selectedNationality.nationalityCode);
    }
  };

  const handleOptionChange = (e) => {
    setSelectedOption(e.target.value);
  };


  useEffect(() => {
    // Fetch the card counts from the API
    const fetchCardCounts = async () => {
      try {
        const API_BASE_URL = window.APP_CONFIG?.API_BASE_URL;

        const response = await axios.get(`${API_BASE_URL}/Dashboard/${0}`);
        setCardCounts({
          mobileCheckOutCount: response.data.groupChkout,
          qrcodeCheckOutCount: response.data.groupWQChkout,
          totalcodeCheckOutCount: response.data.totalGroupCheckout,
        });
      } catch (error) {
        console.error('Error fetching card counts:', error);
      }
    };
    const getNationality = async () => {
      try {
        const nation = await fetchNationality();
        setNationalityList(nation);
        const defaultNation = nation.find(item => item.isDefault);
        if (defaultNation) {
          setDefaultNationalityCode(defaultNation.nationalityCode);
        }
      } catch (error) {
        console.error('Error fetching meeting venues:', error);
      }
    };

    getNationality();

    fetchCardCounts();
  }, []);
  const handleInputChange = (e) => {
    // Only allow numeric input
    if (/^\d*$/.test(e.target.value)) {
      setMobileNumber(e.target.value);
    }

    // setMobileNumber(e.target.value);
  };
  const handleInputQrChange = (e) => {
    const input = e.target.value.replace(/\s+/g, ''); // Removes all spaces from the input
    setQrNumber(input);
  };




  const handleNextButtonClick = async () => {
    if (mobileNumber.trim() === "") {
      toast.error("Please enter the mobile number");
      return;
    }
    if (!defaultNationalityCode) {
      toast.error("Please select the nationality");
      return;
    }
    const formattedMobileNumber = `${defaultNationalityCode}-${mobileNumber}`;
    try {

      const responseAppointment = await axios.get(`/GroupCheckIn/GroupCheckIn/${formattedMobileNumber}`);
      console.log('Checkout Appointment API:', responseAppointment.data);
      if (responseAppointment.data.messageToVisitor == "Nationality code does not match") {
        toast.error("Nationality code does not match")
        return;
      }
      if (responseAppointment.data.messageToVisitor == "Group checkin details not available") {
        toast.error('Group checkin details not available')
        return
      }
      if (responseAppointment.data.checkOutType === "OUT       ") {
        setMobileNumber('');
        setShowPopup(true);
        return;
      }
      if (responseAppointment.data) {
        const responsev = await axios.get(`/GroupAppointment/GroupAppointment/${formattedMobileNumber}`);


        const responseVisitorDeatils = await axios.put(`/GroupCheckIn/${formattedMobileNumber}`);
        console.log("responseVisitorDeatils", responseVisitorDeatils.data);

        const AppId = responseAppointment.data.groupAppointmentId
        console.log("AppId", AppId);
        const Stat = "OUT"
        console.log("Stat", Stat);
        const updateAppoinmentStatus = await axios.post(`/GroupAppointment/AppointStatusUpd/${AppId},${Stat}`);
        console.log('update GroupAppointment API:', updateAppoinmentStatus);
        const empID = localStorage.getItem('employeeId');
        const getManagerDetails = await axios.get(`/Employee/${empID}`);
        const updatedFormData = {
          VisitorName: responseAppointment.data.visitorName,
          MailSubject: 'Visitor CheckOut Notification',
          MailType: 'CHKOUTVISITOR',
          MeetingOn: responseAppointment.data.checkInDateTime,
          VisitorMobile: responseAppointment.data.visitorMobile,
          MeetingVenue: responsev.data.meetingVenue || '',
          txtManagersID: null,
          ManagerMail: getManagerDetails.data.managerMailID,
          SecsEmailId: null,
          VisitorCompany: responseAppointment.data.visitorCompany,
          HostName: getManagerDetails.data.employeeName,
          ToAddress: responseAppointment.data.hostEmail,
        }
        const updatedFormDatav = {
          VisitorName: responseAppointment.data.visitorName,
          MailSubject: 'Visitor CheckOut Notification',
          MailType: 'CHKOUTVISITOR',
          MeetingOn: responseAppointment.data.checkInDateTime,
          VisitorMobile: responseAppointment.data.visitorMobile,
          MeetingVenue: responsev.data.meetingVenue || '',
          txtManagersID: null,
          ManagerMail: getManagerDetails.data.managerMailID,
          SecsEmailId: null,
          VisitorCompany: responseAppointment.data.visitorCompany,
          HostName: getManagerDetails.data.employeeName,
          ToAddress: responsev.data.visitorEmail,
        }
        console.log("updatedFormData", updatedFormData);
        const updateMail = await axios.post('/Mail', updatedFormData);
        const updateMailv = await axios.post('/Mail', updatedFormDatav);

        console.log("updateMail", updateMail);
        const sendSmsData = {
          AppointmentDtTm: responseAppointment.data.checkInDateTime,
          AppointmentVenue: responseAppointment.data.meetingvenue || '',
          ContactNo: "+91" + responseAppointment.data.hostMobile,
          HostName: responseAppointment.data.hostName,
          SMSType: "MsgToHostCHKOUT",
          VisitorName: responseAppointment.data.visitorName
        }
        // console.log("sendSmsData", sendSmsData);
        // const updateSendSms = await axios.post('/SendSMS', sendSmsData);
        // console.log("updateSendSms", updateSendSms);
        setMobileNumber('');
        const fetchCardCounts = async () => {
          try {
            const API_BASE_URL = window.APP_CONFIG?.API_BASE_URL;

            const response = await axios.get(`${API_BASE_URL}/Dashboard/${0}`);
             setCardCounts({
            mobileCheckOutCount: response.data.groupChkout,
            qrcodeCheckOutCount: response.data.groupWQChkout,
            totalcodeCheckOutCount: response.data.totalGroupCheckout,
        });
          } catch (error) {
            console.error('Error fetching card counts:', error);
          }
        };

        fetchCardCounts();
        setShowPopupSuc(true)


      }



    } catch (error) {
      console.error('Error fetching appointment details:', error);
      // Handle error scenarios
    }
  };

  function decodeCheckInId(qrcode) {
    // Mapping encoded byte pairs back to digits
    const reverseMapping = {
      "515253": "1",
      "303030": "3",
      "505050": "5",
      "202020": "2",
      "868484": "4",
      "606060": "6",
      "707070": "7",
      "808080": "8",
      "909090": "9",
      "000000": "0"
    };

    let checkInId = '';

    // Loop through the qrcode string in steps of 6 characters (each code is 6 characters long)
    for (let i = 0; i < qrcode.length; i += 6) {
      const segment = qrcode.substring(i, i + 6); // Extract each 6-character segment
      // Check if the segment exists in the reverse mapping
      if (reverseMapping[segment]) {
        checkInId += reverseMapping[segment]; // Map the segment back to the corresponding digit
      } else {
        console.error(`Error: Segment ${segment} not found in reverse mapping`);
        return ''; // Return an empty string if an invalid segment is encountered
      }
    }

    return checkInId; // Return the decoded check-in ID
  }

  const handleNextButtonQRClick = async () => {
    if (qrumber == '') {
      toast.error("Please enter the QR code")
      return
    }

    console.log("QrCode", qrumber);
    const decryptedNumber = decodeCheckInId(qrumber);
    console.log("decryptedNumber", decryptedNumber);
    try {
      const responseAppointment = await axios.put(`/GroupCheckin/QRCodeCheckOut/${qrumber},${true}`);
      setQrNumber('');
      console.log(responseAppointment);
      if(responseAppointment.data == "Already checked out"){
        toast.error("Already checked out")
        return
      }
      if (responseAppointment.data == "Successfully checkedOut") {
        toast.success(responseAppointment.data)
        const fetchCardCounts = async () => {
          try {
            const API_BASE_URL = window.APP_CONFIG?.API_BASE_URL;

            const response = await axios.get(`${API_BASE_URL}/Dashboard/${0}`);
            setCardCounts({
              mobileCheckOutCount: response.data.groupChkout,
              qrcodeCheckOutCount: response.data.groupWQChkout,
              totalcodeCheckOutCount: response.data.totalGroupCheckout,
            });
          } catch (error) {
            console.error('Error fetching card counts:', error);
          }
        };
        setShowPopupSuc(true)
        fetchCardCounts();
        setQrNumber('');

      }
      const fetchCardCounts = async () => {
        try {
          const API_BASE_URL = window.APP_CONFIG?.API_BASE_URL;

          const response = await axios.get(`${API_BASE_URL}/Dashboard/${0}`);
          setCardCounts({
            mobileCheckOutCount: response.data.groupChkout,
            qrcodeCheckOutCount: response.data.groupWQChkout,
            totalcodeCheckOutCount: response.data.totalGroupCheckout,
          });
        } catch (error) {
          console.error('Error fetching card counts:', error);
        }
      };
      fetchCardCounts();


    } catch (error) {
      setQrNumber('');
    }
    // try {

    //   const responseAppointment = await axios.get(`/GroupCheckIn/GroupCheckIn/${decryptedNumber}`);
    //   console.log('Checkout Appointment API:', responseAppointment.data);
    //   if (responseAppointment.data.checkOutType === "OUT       ") {
    //     setQrNumber('');
    //     setShowPopup(true);
    //     return;
    //   }
    //   if (responseAppointment.data) {
    //     const responsev = await axios.get(`/GroupAppointment/GroupAppointment/${decryptedNumber}`);
    //     const responseVisitorDeatils = await axios.put(`/GroupCheckIn/QRCheckOut/${decryptedNumber}`);
    //     console.log("responseVisitorDeatils", responseVisitorDeatils.data);


    //     const AppId = responseAppointment.data.groupAppointmentId
    //     console.log("AppId", AppId);
    //     const Stat = "OUT"
    //     console.log("Stat", Stat);
    //     const updateAppoinmentStatus = await axios.post(`/GroupAppointment/AppointStatusUpd/${AppId},${Stat}`);
    //     console.log('update GroupAppointment API:', updateAppoinmentStatus);
    //     const empID = localStorage.getItem('employeeId');
    //     const getManagerDetails = await axios.get(`/Employee/${empID}`);
    //     const updatedFormData = {
    //       VisitorName: responseAppointment.data.visitorName,
    //       MailSubject: 'Visitor CheckOut Notification',
    //       MailType: 'CHKOUTVISITOR',
    //       MeetingOn: responseAppointment.data.checkInDateTime,
    //       VisitorMobile: responseAppointment.data.visitorMobile,
    //       MeetingVenue: responsev.data.meetingVenue || '',
    //       txtManagersID: null,
    //       ManagerMail: getManagerDetails.data.managerMailID,
    //       SecsEmailId: null,
    //       VisitorCompany: responseAppointment.data.visitorCompany,
    //       HostName: getManagerDetails.data.employeeName,
    //       ToAddress: responseAppointment.data.hostEmail,
    //     }
    //     const updatedFormDatav = {
    //       VisitorName: responseAppointment.data.visitorName,
    //       MailSubject: 'Visitor CheckOut Notification',
    //       MailType: 'CHKOUTVISITOR',
    //       MeetingOn: responseAppointment.data.checkInDateTime,
    //       VisitorMobile: responseAppointment.data.visitorMobile,
    //       MeetingVenue: responsev.data.meetingVenue || '',
    //       txtManagersID: null,
    //       ManagerMail: getManagerDetails.data.managerMailID,
    //       SecsEmailId: null,
    //       VisitorCompany: responseAppointment.data.visitorCompany,
    //       HostName: getManagerDetails.data.employeeName,
    //       ToAddress: responsev.data.visitorEmail,
    //     }
    //     console.log("updatedFormData", updatedFormData);
    //     const updateMail = await axios.post('/Mail', updatedFormData);
    //     const updateMailV = await axios.post('/Mail', updatedFormDatav);

    //     console.log("updateMail", updateMail);
    //     const sendSmsData = {
    //       AppointmentDtTm: responseAppointment.data.checkInDateTime,
    //       AppointmentVenue: responseAppointment.data.meetingvenue || '',
    //       ContactNo: "+91" + responseAppointment.data.hostMobile,
    //       HostName: getManagerDetails.data.employeeName,
    //       SMSType: "MsgToHostCHKOUT",
    //       VisitorName: responseAppointment.data.visitorName
    //     }
    //     console.log("sendSmsData", sendSmsData);
    //     const updateSendSms = await axios.post('/SendSMS', sendSmsData);
    //     console.log("updateSendSms", updateSendSms);
    //     setQrNumber('');
    //     const fetchCardCounts = async () => {
    //       try {
    //         const response = await axios.get(`https://vmsdemorcjy-a0gch6dtdqbaeebf.southindia-01.azurewebsites.net/api/Dashboard/${0}`);
    //         setCardCounts({
    //           mobileCheckOutCount: response.data.groupChkout,
    //           qrcodeCheckOutCount: response.data.groupWQChkout,
    //         });
    //       } catch (error) {
    //         console.error('Error fetching card counts:', error);
    //       }
    //     };

    //     fetchCardCounts();
    //     setShowPopupSuc(true)


    //   }


    // } catch (error) {
    //   console.error('Error fetching appointment details:', error);
    //   // Handle error scenarios
    // }
  };
  const handleClosePopup = () => {
    setShowPopup(false);
  };
  const handleClosePopupSuc = () => {
    setShowPopupSuc(false);
  };


  function decryptQRCode(qrCode) {
    let decryptedNumber = '';
    for (let i = 0; i < qrCode.length; i += 2) {
      const asciiValue = qrCode.substring(i, i + 2);
      decryptedNumber += String.fromCharCode(parseInt(asciiValue, 10));
    }

    // Use a regular expression to extract only the digits from the decrypted string
    const mobileNumber = decryptedNumber.match(/\d+/)[0];
    return mobileNumber;
  }


  return (
    <Container>
      <Heading>Group Check-Out Count</Heading>
      <CardWrapper>
        <Card bgColor="#A2BECB">
          <CardContent>
            <CardImage src={cardone} alt="Card Image" />
            <CardText>
              <CardTitle>Mobile Check-Out</CardTitle>
              <CardSubtitle>Today's Count</CardSubtitle>
            </CardText>
            <CardCount>{cardCounts.mobileCheckOutCount}</CardCount>
          </CardContent>
        </Card>
        <Card bgColor="#A2BECB">
          <CardContent>
            <CardImage src={cardtwo} alt="Card Image" />
            <CardText>
              <CardTitle>QR Code Check-Out</CardTitle>
              <CardSubtitle>Today's Count</CardSubtitle>
            </CardText>
            <CardCount>{cardCounts.qrcodeCheckOutCount}</CardCount>
          </CardContent>
        </Card>
        <Card bgColor="#7C7C7C">
          <CardContent>
            <CardImage src={cardthree} alt="Card Image" />
            <CardText>
              <CardTitle textColor="#fff">Total Check-Out</CardTitle>
              <CardSubtitle textColor="#fff">Today's Count</CardSubtitle>
            </CardText>
            <CardCount textColor="#fff">{cardCounts.totalcodeCheckOutCount}</CardCount>
          </CardContent>
        </Card>
      </CardWrapper>
      <SubHeading>Check-Out</SubHeading>
      <RadioGroup>
        <RadioLabel>
          <RadioInput
            type="radio"
            value="mobile"
            checked={selectedOption === 'mobile'}
            onChange={handleOptionChange}
          />
          Using Mobile Number
        </RadioLabel>
        <RadioLabel>
          <RadioInput
            type="radio"
            value="qr"
            checked={selectedOption === 'qr'}
            onChange={handleOptionChange}
          />
          Using QR Code
        </RadioLabel>
      </RadioGroup>
      <InputCard>
        {selectedOption === 'mobile' && (
          <>
            <InputWrapper>
              {/* <span>ISD+{defaultNationalityCode}</span> */}
              <ISDSelect onChange={handleIsdChange} value={defaultNationalityCode} 
              title={
                Array.isArray(nationalityList) && nationalityList.length > 0
                  ? (() => {
                      const selectedNation = nationalityList.find(
                        (nation) => nation.nationalityCode === defaultNationalityCode
                      );
                      return selectedNation
                        ? `${selectedNation.name} (${selectedNation.nationalityCode})`
                        : 'Select Nationality';
                    })()
                  : 'Loading...'
              }
              >
                {Array.isArray(nationalityList) && nationalityList.length > 0 ? (
                  <>
                    <option value="" disabled selected>
                      Select Nationality
                    </option>
                    {nationalityList.map((nation) => (
                      <option
                        key={nation.id}
                        value={nation.nationalityCode}
                        disabled={nation.isBlackListed}
                      >
                        {nation.name} ({nation.nationalityCode})
                      </option>
                    ))}
                  </>
                ) : (
                  <option value="" disabled>Loading...</option>
                )}
              </ISDSelect>
              <StyledInput
                type="text"
                maxLength={defaultNationalityCode === "91" ? 10 : 15}
                value={mobileNumber}
                onChange={handleInputChange}
                placeholder="Enter  Mobile Number"
              />
            </InputWrapper>
            <Button onClick={handleNextButtonClick}>Next</Button>
          </>
        )}
        {selectedOption === 'qr' && (
          <>
            <InputField
              type="text"
              placeholder="Scan QR Code"
              value={qrumber}
              onChange={handleInputQrChange}
            />
            <Button onClick={handleNextButtonQRClick}>Next</Button>
          </>
        )}
      </InputCard>
      {showPopup && (
        <Popup>
          <PopupText>Checkout already done for this Visitor</PopupText>
          <PopupButton onClick={handleClosePopup}>OK</PopupButton>
        </Popup>
      )}
      {showPopupSuc && (
        <Popup>
          <PopupText> Visitor Left</PopupText>
          <PopupButton onClick={handleClosePopupSuc}>OK</PopupButton>
        </Popup>
      )}
      <ToastContainer />
    </Container>
  );
};

export default GroupCheckoutPage;
